// Shared building blocks for the data-table views (Records, Agencies,
// Docket, AI Reports, Associated Records modal) — extracted so the Ghosted
// stage color (bugfix 3.1) and hotStatus sort order (bugfix 2.2) can't
// silently re-diverge by being copy-pasted into yet another view.

// Stage chip color, shared by every table that renders a Stage/status chip.
export function getStageColor(stage) {
  if (!stage) return 'grey';
  const s = stage.toLowerCase();
  if (s.includes('bullpenx')) return 'grey-lighten-1';
  if (s.includes('received') || s.includes('video') || s.includes('complete')) return 'green-lighten-4';
  if (s.includes('denied') || s.includes('no footage') || s.includes('no records')) return 'red-lighten-2';
  if (s.includes('kill')) return 'red-lighten-4';
  if (s.includes('ghosted')) return 'blue-grey-lighten-3';
  if (s.includes('quote') || s.includes('invoice') || s.includes('payment')) return 'orange-lighten-4';
  if (s.includes('paid')) return 'teal-lighten-4';
  if (s.includes('bullpen')) return 'purple-lighten-4';
  if (s.includes('pending') || s.includes('open')) return 'blue-lighten-4';
  return 'grey-lighten-3';
}

// hotStatus sort priority: Hot(2) > Good(1) > Standard(0) > Cool(3) > Avoid(4).
// Used by every column/header sort on the hotStatus/Rating field.
const HOT_STATUS_PRIORITY = { 2: 4, 1: 3, 0: 2, 3: 1, 4: 0 };
export function getHotPriority(hotStatus) {
  return HOT_STATUS_PRIORITY[hotStatus] !== undefined ? HOT_STATUS_PRIORITY[hotStatus] : 2;
}
export function compareHotStatus(a, b) {
  return getHotPriority(a) - getHotPriority(b);
}

// Builds a lowercase-name -> agency-doc Map for O(1) lookups instead of a
// per-row Array.find() scan. First match wins on duplicate names.
export function buildAgencyLookup(agencies) {
  const map = new Map();
  (agencies || []).forEach(a => {
    const key = (a.agencyName || a.Agency || a.name || '').trim().toLowerCase();
    if (key && !map.has(key)) map.set(key, a);
  });
  return map;
}

// Shared items-per-page choices for the Records/Agencies tables.
export const ITEMS_PER_PAGE_OPTIONS = [
  { title: '25', value: 25 },
  { title: '50', value: 50 },
  { title: '100', value: 100 },
  { title: 'All', value: -1 },
];
